module.exports = __webpack_public_path__ + "46ff2d695067a92a45d85d2d5333a1cc.pdf";